"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.debugExpireTokenValidity = exports.dismissError = exports.logout = undefined;
exports.logoutOnUnauthorizedApiError = logoutOnUnauthorizedApiError;
exports.login = login;

var _index = require("./index");

var _reduxActions = require("redux-actions");

var _clientDate = require("../../core/clientDate");

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _lodash = require("lodash");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments)).next());
    });
};

// internal action creators
function loginPending(username, shouldRememberUser) {
    return {
        type: _index.AUTH_LOGIN,
        payload: {
            username: username,
            shouldRememberUser: shouldRememberUser
        }
    };
}
function loginSuccess(accessToken, refreshToken, expiresIn, scope, guildId) {
    return {
        type: _index.AUTH_LOGIN_SUCCESS,
        payload: {
            accessToken: accessToken,
            refreshToken: refreshToken,
            expiresAt: (0, _clientDate.applyMillisecondsToCurrentDate)(expiresIn),
            scope: scope,
            guildId: guildId
        }
    };
}
function loginFailed(error) {
    return {
        type: _index.AUTH_LOGIN_FAILED,
        error: error.message,
        payload: {
            errorStatus: error.response ? error.response.status : -1
        }
    };
}
function logoutGlobalSecurityError(statusCode) {
    return {
        type: _index.AUTH_GLOBAL_SECURITY_ERROR,
        error: "\nGlobaler Sicherheitsfehler: AccessToken nicht gültig. \n\nCode: " + statusCode + "\nlogoutGlobalSecurityError\n",
        payload: {
            errorStatus: statusCode
        }
    };
}
// public action creators
var logout = exports.logout = (0, _reduxActions.createAction)(_index.AUTH_LOGOUT);
var dismissError = exports.dismissError = (0, _reduxActions.createAction)(_index.AUTH_DISMISS_ERROR);
// debug action creators
// utility method to apply clear login token (for testing on global security error logout handling)
// only available through the console.
var debugExpireTokenValidity = exports.debugExpireTokenValidity = (0, _reduxActions.createAction)(_index.AUTH_DEBUG_TOKEN_VALIDITY_EXPIRED);
function logoutOnUnauthorizedApiError(action) {
    return function (dispatch, getState) {
        var statusCode = (0, _selectn2.default)("payload.status", action);
        if (getState().auth.isAuthenticated && (0, _lodash.includes)([_constants.FETCH_STATUS_UNAUTHORIZED, _constants.FETCH_STATUS_FORBIDDEN], statusCode)) {
            dispatch(logoutGlobalSecurityError(statusCode));
        }
    };
}
// public thunk action creators
function login(API, client, requiredScope) {
    return function login(username, password, shouldRememberUser) {
        var _this = this;

        return function (dispatch, getState) {
            return __awaiter(_this, void 0, void 0, regeneratorRuntime.mark(function _callee() {
                var loginResponse, profileResponse, accessToken, refreshToken, expiresIn;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(getState().auth.isLoading === true)) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt("return");

                            case 2:
                                dispatch(loginPending(username, shouldRememberUser));
                                _context.prev = 3;
                                _context.next = 6;
                                return client.requestType(API.login(username, password, requiredScope));

                            case 6:
                                loginResponse = _context.sent;
                                _context.next = 9;
                                return client.requestType(API.getProfile(loginResponse.accessToken));

                            case 9:
                                profileResponse = _context.sent;
                                accessToken = loginResponse.accessToken;
                                refreshToken = loginResponse.refreshToken;
                                expiresIn = loginResponse.expiresIn;

                                dispatch(loginSuccess(accessToken, refreshToken, expiresIn, profileResponse.profile.scope, profileResponse.profile.guildId));
                                _context.next = 19;
                                break;

                            case 16:
                                _context.prev = 16;
                                _context.t0 = _context["catch"](3);

                                dispatch(loginFailed(_context.t0));

                            case 19:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[3, 16]]);
            }));
        };
    };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/reducers/auth/actions.ts
 ** module id = 647
 ** module chunks = 0
 **/